import { createGtm } from '@gtm-support/vue-gtm'

/**
 * dataLayer events (useGtm().trackEvent) and a content-view on every route change.
 *
 * Replaces @zadigetvoltaire/nuxt-gtm, which supports only Nuxt 3 and was the same thin wrapper around vue-gtm
 * (Nuxt 4 upgrade 4.11.2026). The options are in runtimeConfig.public.gtm as before. GTM itself is loaded by the
 * delayed loader in <head> (config/gtmLoader.ts), so loadScript is false.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const options = useRuntimeConfig().public.gtm
  nuxtApp.vueApp.use(createGtm({
    ...options,
    vueRouter: options.enableRouterSync ? useRouter() : undefined
  }))
})
